import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import {abastecimentosRoute} from "../../shared/data.service";
import {locaisRoute} from "./data.service";

@Injectable()
export class LocalNavigationService {

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = abastecimentosRoute + '/' + locaisRoute;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = abastecimentosRoute + '/' + locaisRoute + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = abastecimentosRoute + '/' + locaisRoute + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/shared/local-navigation.service.ts
 **/